"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const team = [{
  name: "Darin Bowling",
  role: "Founder & Lead Investor",
  image: "https://newchapterpropertysolutions.com/wp-content/uploads/2026/03/liftapp-1.png?v=z9mswrlqz8",
  linkedin: "https://linkedin.com"
}, {
  name: "Leigha Juillerat",
  role: "Acquisitions Manager",
  image: "https://newchapterpropertysolutions.com/wp-content/uploads/2026/03/liftapp-4.png?v=5yvyi0jtfwt",
  linkedin: "https://linkedin.com"
}];
export default function MeetTheInvestors() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="meet-the-investors" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-sans">
            Meet the Investors
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            Our team of experienced local real estate professionals is dedicated to providing transparent, fair, and fast solutions for homeowners.
          </p>
        </div>

        <div ref={ref} className={`mt-16 grid max-w-2xl grid-cols-1 gap-8 mx-auto sm:grid-cols-2 lg:max-w-4xl lg:gap-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {team.map((member, i) => <div key={member.name} data-index={i} className="group relative overflow-hidden rounded-2xl bg-muted aspect-[4/5] shadow-md transition-all duration-300 hover:shadow-xl">
              {}
              <img src={member.image} alt={`Portrait of ${member.name}`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90 transition-opacity duration-300 group-hover:opacity-100" />

              {}
              <div className="absolute top-4 right-4 z-10 translate-y-[-10px] opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <Link to={member.linkedin} newTab className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 backdrop-blur-md text-white hover:bg-primary hover:text-primary-foreground transition-colors" aria-label={`${member.name}'s LinkedIn profile`}>
                  <Linkedin className="h-5 w-5" />
                </Link>
              </div>

              {}
              <div className="absolute inset-x-0 bottom-0 p-6 translate-y-2 transition-transform duration-300 group-hover:translate-y-0">
                <h3 className="text-2xl font-bold text-white font-sans">
                  {member.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-white/80 uppercase tracking-wider">
                  {member.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}